const Gender = {
  female: 'female',
  male: 'male',
  nonBinary: 'non-binary',
  none: '',
};

export default Gender;
